module.exports = __webpack_public_path__ + "static/media/logo.6d6e0f96.png";